// A viagem é ida e volta quando existe selectedReturn.key — nunca compare
// idavolta com string: ele é salvo como booleano no sessionStorage (bug PUP).
export const buildBusCheckRateRequest = (dataSelected, searchState) => ({
  goingBus: dataSelected?.selectedDepart?.key,
  goingBusRefToken: dataSelected?.selectedDepart?.refToken || "",
  returnBus: dataSelected?.selectedReturn?.key ?? null,
  returnBusRefToken: dataSelected?.selectedReturn?.key
    ? dataSelected?.selectedReturn?.refToken || ""
    : null,
  occupancy: dataSelected?.passageiros || searchState?.passageiros || "1",
});

export const calcBusPointsTotal = (dataSelected) =>
  (dataSelected?.selectedDepart?.pointsValue || 0) +
  (dataSelected?.selectedReturn?.pointsValue || 0);

// O checkRate não retorna mais `policies`; as regras vêm em
// `cancellationPolicies.penalties`. Mapeia para o shape {name, description}
// que o SimpleBusModal renderiza.
export const mapBusPolicies = (bookingBuses) => {
  if (bookingBuses?.policies?.length) return bookingBuses.policies;

  const { refundable, penalties } = bookingBuses?.cancellationPolicies || {};
  const list = (penalties || []).map((p) => ({
    name: p.name,
    description: [
      p.description,
      p.percent != null && `Multa de ${p.percent}% do valor da tarifa.`,
      p.from &&
        `Válida a partir de ${new Date(p.from).toLocaleDateString("pt-BR")}.`,
    ]
      .filter(Boolean)
      .join("<br/>"),
  }));

  if (refundable === false && !list.length) {
    list.push({
      name: "Política de cancelamento",
      description: "Tarifa não reembolsável.",
    });
  }

  return list;
};
